import { mapGetters, mapActions } from 'vuex'

import headers from './headers'
import {
  DisplaySwitchButton,
  HelpCircle,
  ProductTable
} from '@/components/items'
import { storageUtil, currencyUtil, commonUtil } from '@/util'
import HoverPopNormal from '@/components/layouts/HoverPop/HoverPopNormal'

import DialogAlertError from '@/components/layouts/Dialogs/DialogAlert/DialogAlertError'

export default {
  components: {
    DisplaySwitchButton,
    HelpCircle,
    ProductTable,
    HoverPopNormal,
    DialogAlertError
  },
  props: {
    isEditPage: { default: false },

    isClientSelect: {
      type: Boolean,
      require: true,
      default: false
    },
    isRegist: {
      type: Boolean,
      default: false
    },
    selectCurrency: {
      type: Object,
      require: true,
      default: () => {}
    },
    search: {},
    saleInfo: {},
    clientInfo: {},
    historyProductMoves: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  data: () => ({
    openPanelIndex: [],
    groupNames: [],
    pageProductList: [],
    headers: [],

    productList: [],
    productListData: [],
    productExchangePriceList: [],
    saledSupplierIdList: [],

    fxRate: [],
    errDialog: false,
    // 履歴データ読み込み中であることを示すフラグを追加
    isHistoryMode: false
  }),
  async created() {
    // historyProductMovesのwatchでinitが呼ばれるため、createdでの呼び出しは不要に
    // await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductAndStockListFromApi']),
    ...mapGetters('Product', ['getProductAndStockListFromState']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),
    ...mapActions('Common', ['setIsLoading']),
    notClientSelect() {
      alert(this.$t('sale.sale_select-customer'))
      // this.errDialog = true
    },

    async init() {
      this.setIsLoading(true)
      this.headers = this.isEditPage ? headers.history : headers.register

      await this.createProductListData()
      this.setGroupNames()

      this.checkOpenPanelSupplier()

      await this.setExchangePrice()
      this.setIsLoading(false)
    },
    getSupplierName(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier ? supplier.name : this.$t('common.common_unknown')
    },

    getSupplierIsEnabled(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier.isEnabled
    },

    async createProductListData() {
      const supplierId = null
      await this.getProductAndStockListFromApi({ supplierId: supplierId })
      const productList = this.getProductAndStockListFromState()
        .filter((ele) => {
          const name = ele.nameJp + '' + ele.nameCn
          const nameFilter = this.search.keyword
            ? name.includes(this.search.keyword)
            : true

          const categoryFilter = this.search.category
            ? this.search.category === ele.categoryId
            : true

          return nameFilter && categoryFilter
        })
        .filter((product) => {
          return this.isRegist ? product.isEnabled : true
        })

      this.productList = productList

      await this.getSuppliersFromApi()
      this.pageProductList = productList
        .filter((ele) => {
          return this.getSupplierIsEnabled(ele.supplierId)
        })
        .map((ele, index) => {
          ele.supplierName = this.getSupplierName(ele.supplierId)
          return ele
        })

      const storageIdNameList = await storageUtil.getStorageIdNameList()
      this.productListData = productList.map((ele, index) => {
        const storage = this.getStorageProductStockAndMoving(
          storageIdNameList.data,
          ele
        )
        const order = this.getProductQuantity(ele.productPlanQuantityInfo, 2)
        const sales = this.getProductQuantity(ele.productPlanQuantityInfo, 1)

        const stock = {
          storage: storage,
          order: order ? '※注文済未出庫：' + order : '',
          sales: sales ? '※発注済未入庫：' + sales : ''
        }

        // .find() を .filter() に変更し、該当する全履歴を取得
        let historyItems = []
        if (this.historyProductMoves && this.historyProductMoves.length > 0) {
          historyItems = this.historyProductMoves.filter(
            (historyProduct) =>
              historyProduct.product.productId === ele.productId
          )
        }

        // 履歴が複数ある場合を考慮し、取得した全履歴からsalesDetails配列を生成
        let salesDetails
        if (historyItems.length > 0) {
          // 履歴が1件以上ある場合は、その全件を描画
          salesDetails = historyItems.map((item) => ({
            count: item.quantity,
            price: item.price,
            amount: item.quantity * item.price,
            exportSubjectFlg: item.exportSubjectFlg
          }))
        } else {
          // 履歴がない場合は、空の入力行を1つだけ用意
          let price = null
          if (
            this.fxRate.length > 0 &&
            this.saleInfo &&
            this.saleInfo.saleDate
          ) {
            price = commonUtil.exchangePriceByFxRate(
              ele.taxExcludedRetailPriceCurrencyId,
              this.saleInfo.currency.value,
              ele.taxExcludedRetailPrice * (this.clientInfo.rateAccount / 100),
              this.fxRate
            )
          }
          salesDetails = [
            {
              count: null,
              price: this.formatPrice(price) || 0,
              amount: null,
              exportSubjectFlg: this.isPurchasePriceCurrencyIdJa(
                ele.purchasePriceCurrencyId
              )
            }
          ]
        }

        if (
          historyItems.length > 0 &&
          !this.saledSupplierIdList.includes(ele.supplierId)
        ) {
          this.saledSupplierIdList.push(ele.supplierId)
        }

        return {
          ...ele,
          productId: ele.productId,
          invalid: false,
          supplierId: ele.supplierId,
          stock: stock,
          salesDetails: salesDetails
        }
      })
    },
    addSalesDetail(productId) {
      const product = this.getProductListData(productId)
      if (product) {
        // 現在の行数を確認し、10行以上であればアラートを表示して処理を中断
        if (product.salesDetails.length >= 10) {
          alert(this.$t('sale.sale_duplicate-product-over-10-warning'))
          return
        }
        // 行数が上限未満の場合のみ、新しい行を追加
        // .push() の中で新しいオブジェクト {} を生成することで、各行が独立したデータを持つようにする
        product.salesDetails.push({
          count: null,
          price: 0,
          amount: null,
          exportSubjectFlg: false
        })
      }
    },
    removeSalesDetail(productId, detailIndex) {
      const product = this.getProductListData(productId);
      // salesDetails配列の要素が1つより多い場合のみ削除を実行（最後の1行は消せないようにする）
      if (product && product.salesDetails.length > 1) {
        product.salesDetails.splice(detailIndex, 1);
      }
    },
    checkOpenPanelSupplier() {
      this.openPanelIndex = []
      this.saledSupplierIdList.forEach((supplierId) => {
        const group = this.groupNames.find(
          (group) => group.groupId === supplierId
        )
        if (group && !this.openPanelIndex.includes(group.index)) {
          this.openPanelIndex.push(group.index)
        }
      })
    },
    async setExchangePrice() {
      if (!this.saleInfo) {
        return
      }
      const fxRate = await commonUtil.getFxRate(this.saleInfo.saleDate)
      this.productExchangePriceList = this.productListData.map((ele) => {
        return {
          productId: ele.productId,
          exchangePrice: fxRate
            ? this.getPurchasePriceForSelectedCurrency(ele, fxRate)
            : ''
        }
      })
    },

    getHistoryProduct(productId) {
      this.historyProductMoves.find(
        (ele) => ele.product.productId === productId
      )
    },

    setGroupNames() {
      const productListTmp = [...this.productList]

      this.groupNames = productListTmp
        .sort((a, b) => {
          if (a.supplierId < b.supplierId) return -1
          if (a.supplierId > b.supplierId) return 1
          return 0
        })
        .reduce((result, current) => {
          var element = result.find((p) => p.groupId === current.supplierId)
          if (!element) {
            result.push({
              groupId: current.supplierId,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isOpenPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    isPurchasePriceCurrencyIdJa(id) {
      // TODO 本当は共通method
      if (id === 0) {
        return true
      }
      return false
    },

    getProductQuantity(productQuantity, transactionType) {
      const ret = productQuantity.reduce((result, current) => {
        if (
          !transactionType ||
          Number(current.transactionType) === transactionType
        ) {
          return result + current.quantity
        }
        return result
      }, 0)
      return ret
    },
    getStorageProductStockAndMoving(storageIdNameList, rec) {
      return storageIdNameList.map((ele) => {
        const stock = rec.productStockQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        const moving = rec.productMovingQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        return {
          storageName: ele.label,
          stock: this.getProductQuantity(stock, null),
          moving: this.getProductQuantity(moving, null)
        }
      })
    },

    getProductListData(productId) {
      return this.productListData.find((p) => p.productId === productId)
    },
    getExchangePriceListData(productId) {
      const ret = this.productExchangePriceList.find(
        (p) => p.productId === productId
      )
      return ret ? ret : {}
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },

    changeInvalid(...args) {
      const [invalid] = args

      this.productListData = this.productListData.map((product) => {
        product.invalid = false
        if (invalid.find((ele) => ele === product.productId)) {
          product.invalid = true
        }
        return product
      })

      // 販売商品 無効
      this.$emit('change', false, this.productListData)
    },
    // changeHistoryProductMovesメソッドは不要なため削除
    getPurchasePriceForSelectedCurrency(product, fxRate) {
      if (!this.saleInfo) return ''
      const exchangePrice = commonUtil.exchangePriceByFxRate(
        product.purchasePriceCurrencyId,
        this.selectCurrency.currencyId,
        product.purchasePrice,
        fxRate
      )
      return exchangePrice ? this.formatPrice(exchangePrice) : ''
    },
    getCurrencyName(productInfo) {
      const currencyId = productInfo.purchasePriceCurrencyId
      if (currencyId) {
        return currencyUtil.findCurrencyNameById(currencyId).unitName
      }
      return ''
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    // データ変換用の新しいメソッド
    flattenProductData(groupedData) {
      const flatList = []
      groupedData.forEach((product) => {
        // salesDetails配列が存在し、中身がある場合のみ処理
        if (product.salesDetails && product.salesDetails.length > 0) {
          product.salesDetails.forEach((detail) => {
            // 注文数が入力されており、かつ0より大きい行のみを対象とする
            // これにより、価格が0円でも数量が1以上なら登録対象となります。
            if (detail.count !== null && detail.count > 0) {
              const newProductData = { ...product } // 元の商品情報をコピー
              delete newProductData.salesDetails // 不要なsalesDetails配列は削除

              // 個別の注文情報を追加して、シンプルなオブジェクトを作成
              newProductData.count = detail.count
              // detail.priceがnullやundefinedの場合も考慮し、0として扱う
              newProductData.price = detail.price || 0
              newProductData.amount = newProductData.count * newProductData.price
              newProductData.exportSubjectFlg = detail.exportSubjectFlg || false
              newProductData.currencyId = this.selectCurrency.currencyId

              flatList.push(newProductData)
            }
          })
        }
      })
      return flatList
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    // amount computedは不要なため削除
  },
  watch: {
    openPanelIndex: {
      immediate: true,
      deep: true,
      handler(val) {
        this.setGroupNamesOpen(val)
      }
    },
    search: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    },
    saleInfo: {
      deep: true,
      async handler(newVal, oldVal) {
        this.setIsLoading(true)
        this.setExchangePrice()

        if (this.saleInfo && this.saleInfo.saleDate) {
          this.fxRate = await commonUtil.getFxRate(this.saleInfo.saleDate)
          await this.createProductListData()
        }
        this.setIsLoading(false)
      }
    },

    // historyProductMovesの監視方法を修正
    historyProductMoves: {
      deep: true,
      immediate: true, // コンポーネント作成時に即時実行
      async handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.isHistoryMode = true // 履歴モードフラグを立てる
          await this.init() // データを再初期化
        } else if (!newVal || newVal.length === 0) {
          // 履歴がない場合も初期化を実行
          this.isHistoryMode = false
          await this.init()
        }
      }
    },
    productListData: {
      deep: true,
      handler(newValue) {
        // データを送信する前に、フラットな形式に変換する
        const flatData = this.flattenProductData(newValue)

        // 変換後のシンプルなデータを親コンポーネントに渡す
        // isHistoryModeフラグを使って、履歴データからの初回読み込みかどうかを伝える
        this.$emit('change', this.isHistoryMode, flatData)

        // 初回通知が終わったら、フラグを戻す
        this.isHistoryMode = false
      }
    }
  }
}
